export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'rowlett' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'rowlett'
